angular.module('app.filters')
.filter('selectedInhouseTags', [
  '$log', 'sharedProperties', function($log, sharedProperties) {
    return function(jobsList, selectedPractice) {
      var count, selected_jobs;
      selected_jobs = [];
      count = 0;
      jobsList.forEach(function(job, index, array) {
        job.ref_practices.forEach(function(pa, index, array) {
          if (sharedProperties.isNotNullOrEmpty(_.find(selectedPractice, function(prac) {
            return prac.practice_ID === pa.refPracticePracticeID;
          })) && pa.isSelected) {
            job.dontExist = false;
            if (!(selected_jobs.indexOf(job) > -1)) {
              selected_jobs.push(job);
            }
          }
        });
        jobsList = angular.copy(selected_jobs);
      });
      return jobsList;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/selected-inhouse-tags.js